module.exports = __webpack_public_path__ + "00a74a0009d86768fe0e8323f3f8f115.otf";